import React from 'react';
import { Box } from '@material-ui/core';
import moment from 'moment';

export const discoveryAppUsers = [
  { Header: 'User Id', accessor: '_id' },
  { Header: 'User Name', accessor: 'name' },
  {
    Header: 'Mobile',
    accessor: 'mobile',
  },
  { Header: 'City', accessor: 'city' },
  {
    Header: 'App Regester Date',
    accessor: 'appRegesterDate',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { appRegesterDate } = payload;
      return (
        <>
          <Box>{moment(appRegesterDate).format('MMMM Do, YYYY')}</Box>
        </>
      );
    },
  },
  {
    Header: 'App Earning',
    accessor: 'appEarning',
  },
  // {
  //   Header: 'Action',
  //   accessor: '',
  //   Cell: () => {
  //     const [anchorEl, setAnchorEl] = React.useState(null);
  //     const open = Boolean(anchorEl);

  //     const handleClick = (event) => {
  //       setAnchorEl(event.currentTarget);
  //     };

  //     const handleClose = () => {
  //       setAnchorEl(null);
  //     };
  //     const options = ['Active', 'Deactive', 'Delete'];
  //     const ITEM_HEIGHT = 48;
  //     return (
  //       <>
  //         <Box display="flex">
  //           <Box
  //             width={80}
  //             // onClick={setDetails}
  //             // component={Link}
  //             // to={`${CONFIRM_ADMISSIONS_VIEW_DETAILS_ROUTE}?leadId=${leadId}&schoolId=${schoolId}&formId=${formId}`}
  //             fontSize={14}
  //             // className={classes.textStyle}
  //             // style={{ cursor: 'not-allowed' }}
  //           >
  //             {/* View */}
  //             <IconButton
  //               aria-label="more"
  //               aria-controls="long-menu"
  //               aria-haspopup="true"
  //               onClick={handleClick}>
  //               <MoreVertIcon />
  //             </IconButton>
  //             <Menu
  //               id="long-menu"
  //               anchorEl={anchorEl}
  //               keepMounted
  //               open={open}
  //               onClose={handleClose}
  //               PaperProps={{
  //                 style: {
  //                   maxHeight: ITEM_HEIGHT * 4.5,
  //                   width: '20ch',
  //                 },
  //               }}>
  //               {options.map((option) => (
  //                 <MenuItem
  //                   key={option}
  //                   selected={option === 'Pyxis'}
  //                   onClick={handleClose}>
  //                   {option}
  //                 </MenuItem>
  //               ))}
  //             </Menu>
  //           </Box>
  //         </Box>
  //       </>
  //     );
  //   },
  // },
];
